"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteWatchlistService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var AuthSuiteWatchlistService = /** @class */ (function () {
    function AuthSuiteWatchlistService() {
        var _this = this;
        this.addToWatchlist = function (contentId) {
            var addToWatchListRoute = _this.watchListBaseRoute;
            var payload = { contentId: contentId };
            var body = JSON.stringify(payload);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
                body: body,
                path: addToWatchListRoute,
            });
        };
        this.removeFromWatchlist = function (contentId) {
            var removeFromWatchListRoute = "".concat(_this.watchListBaseRoute, "/byContentId/").concat(contentId);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.delete({
                path: removeFromWatchListRoute,
            });
        };
        this.deleteFromWatchlist = function (contentIds) {
            var removeFromWatchListRoute = _this.watchListBaseRoute;
            var payload = { contentIds: contentIds };
            var body = JSON.stringify(payload);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.delete({
                body: body,
                path: removeFromWatchListRoute,
            });
        };
        this.containsOnWatchlist = function (contentId) {
            var existsOnWatchListRoute = "".concat(_this.watchListBaseRoute, "/byContentId/").concat(contentId, "/exists");
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
                path: existsOnWatchListRoute,
            });
        };
        this.watchListBaseRoute = "watchlist";
    }
    return AuthSuiteWatchlistService;
}());
exports.AuthSuiteWatchlistService = AuthSuiteWatchlistService;
